import {
	Button, Dialog, DialogActions, DialogContent, DialogContentText,
	DialogTitle, Tooltip
} from '@material-ui/core';
import React, { useState } from 'react';
import { useActions, useValues } from 'kea';

import alertlogic from 'src/store/alert';


const stolenAlert = '6375d245f0aad89ba8ee927e';

const RemoveAlertDialog = ({ alert, reset }) => {
	const [open, setOpen] = useState(false);

	const { remove } = useActions(alertlogic);

	const handleClickOpen = () => {
		setOpen(true);
	}

	const handleClose = () => {
		setOpen(false);
	}

	const handleRemove = () => {
		let validated = true;
		if (!alert) {
			validated = false;
		}
		if (validated) {
			remove(alert);
			reset();
			setOpen(false);
		}
	}
	return (
		<div>
			<Tooltip title="Remove selected alert">
				<Button
					color="default"
					variant="contained"
					aria-label="add"
					onClick={handleClickOpen}
					size='large'
					disabled={alert._id === stolenAlert}
				>
					Remove
				</Button>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{"Remove Alert?"}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Remove the Alert?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handleRemove} color="primary">
						Confirm Remove
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}


export default RemoveAlertDialog
